module.exports = __webpack_public_path__ + "static/media/screenshot1.b611c66e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/kudos/screenshot1.png
// module id = 40
// module chunks = 0